import React from 'react';
import { sessionManager } from '../../core/SessionManager';
import { Layout, Tooltip } from 'antd';
import { LogoutOutlined, OrderedListOutlined } from '@ant-design/icons';
import { post } from '../../utils/http'
import api from '../../utils/api'

const { Header } = Layout;

export default function DashNav(props) {

  const username = sessionManager.getMerchantId() === null ? sessionManager.getUserInfo().userName : sessionManager.getMerchantName();
  
  const handleLogout = () => {
    post(api.removePrivilege).then(function (response) {
        removePrivilege()
    }).catch(function (error) {
        removePrivilege()
    }) 
  };

  function removePrivilege() {
    sessionManager.signout()
    window.location.reload();
  }

  return (
    <Header style={{ backgroundImage: "linear-gradient(to right, #4c468e 0%, #aa3085 100%)", display: 'flex', justifyContent: 'space-between', padding: '10px,20px' }}>
      <div style={{ float: 'left', fontSize: '18px' }}>
      </div>
      <div style={{ fontSize: '26px' }}>

        <span style={{ marginLeft: 15 }}>
          Dash Portal
        </span>
      </div>
      <div style={{ fontSize: '20px' }}>
        Welcome, {username}
        <Tooltip placement="bottom" title="logout" >
          <LogoutOutlined onClick={handleLogout} style={{ marginLeft: 15, fontSize: '20px', lineHeight: '64px' }} />
        </Tooltip>
      </div>
    </Header>
  );
}
